<template>
	<div class="mod-personal" v-loading="listLoading" element-loading-text="数据加载中">
		<div class="mod-header">
			<div class="tab-list">
				<span class="tab-item" :class="currentTabIndex == index ? 'active' : ''" @click="tabChangeHandle(index)" v-for="(item, index) of tabs" :key="index">{{ item.name }}</span>
			</div>
		</div>
		<div class="mod-pagemain">
			<el-table :key="tableKey" :data="tableData" @row-dblclick="dbRowClickHandle" style="width: 100%">
				<template v-for="(item, index) of tHeader">
					<el-table-column :label="item.label" align="center" :key="index" v-if="item.type != 'button'">
						<el-table-column :prop="item.post" show-overflow-tooltip :width="item.options && item.options.weight ? item.options.weight + 'px' : ''" align="center">
							<template slot="header" slot-scope="{}">
								<span v-if="item.type === 'input'">
									<el-input v-model="searchForm[item.post]" size="mini" clearable prefix-icon="el-icon-search" @change="filterHandle" placeholder="请输入" />
								</span>
								<span slot="header" v-if="item.type === 'select'">
									<el-select v-model="searchForm[item.post]" size="mini" clearable prefix-icon="el-icon-search" @change="filterHandle" placeholder="请选择">
										<el-option :label="op.label" :value="op.code" v-for="(op, index) of item.options.valueData" :key="index"></el-option>
									</el-select>
								</span>
								<span slot="header" v-if="item.type === 'date'">
									<el-date-picker @change="filterHandle" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="searchForm[item.post]" style="width: 100%">
									</el-date-picker>
								</span>
							</template>
						</el-table-column>
					</el-table-column>
					<el-table-column :label="item.label" align="center" fixed="right" width="200px" :key="index" v-else>
						<el-table-column :prop="item.post" show-overflow-tooltip fixed="right" width="200px" align="center">
							<template slot-scope="scope">
								<div
									v-if="
										item.type == 'button' &&
										item.options &&
										item.options.button &&
										item.post &&
										scope.row[item.post] &&
										item.options.button[scope.row[item.post]] &&
										item.options.button[scope.row[item.post]].length
									"
									style="width: 100%; overflow-x: auto"
								>
									<el-button
										v-for="(btn, i) in item.options.button[scope.row[item.post]]"
										:key="i"
										:style="{ 'font-size': '14px', padding: '0', color: btn.color || '#333' }"
										type="text"
										@click="btnClick(btn.code, scope.row)"
										>{{ btn.label }}</el-button
									>
								</div>
								<span v-else :style="{ color: getRowColor(item.post, scope.row[item.post]) }">
									{{ scope.row[item.post] }}
								</span>
							</template>
						</el-table-column>
					</el-table-column>
				</template>
			</el-table>
			<!-- 分页 -->
			<Pagination v-if="tableData.length > 0" :total="total" :page.sync="listQuery.current" :limit.sync="listQuery.size" @pagination="getDataList" />
		</div>

		<!-- 时间面板 -->
		<timepanel v-if="timepanelVisible" ref="timepanel" @updateTime="updateTime"></timepanel>
		<!-- 下载附件列表 -->
		<order-down ref="orderDown" :downList="downList" @handleDown="handleDown"></order-down>
		<!-- 预约失败 -->
		<order-fail v-if="orderFailVisible" ref="orderFail" @showTimePanel="showTimePanel"></order-fail>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Timepanel from '../common/Timepanel.vue'
import OrderDown from '../common/dialog/OrderDown.vue'
import OrderFail from '../common/dialog/OrderFail.vue'

import { downloadFile } from '@/utils'
export default {
	components: {
		Pagination,
		Timepanel,
		OrderDown,
		OrderFail,
	},
	data() {
		return {
			//tabs: ["全部订单", "待提交", "审核中", "已驳回", "信息复核", "检验中", "已完成", "已取消"],
			tabs: [],
			currentTabIndex: 0,
			listLoading: false,
			tHeader: [],
			tableData: [],
			searchForm: {},
			dataListSelections: [],
			total: 0,
			listQuery: {
				current: 1,
				size: 10,
			},
			tableKey: new Date().getTime(),
			timepanelVisible: false,
			updatOrderId: null,
			downList: [],
			orderFailVisible: false,
			rowCont: {},
		}
	},
	created() {
		this.getDataList()
	},
	computed: {
		surveyVisible: {
			get() {
				return this.$store.state.surveyVisible
			},
			set(val) {
				this.$store.commit('updateSurveyVisible', val)
			},
		},
	},
	methods: {
		// 获取列表
		getDataList() {
			this.listLoading = true
			let params = {
				...this.listQuery,
				data: {
					...this.searchForm,
					state: this.tabs.length > 0 ? this.tabs[this.currentTabIndex].id : '',
				},
			}
			this.$http
				.post(this.$api.orderApi.orderList, params)
				.then(({ data }) => {
					console.log(data)
					let res = data.data
					let currObj = res[this.currentTabIndex]
					this.tabs = res.map(item => {
						return { id: item.id, name: item.name }
					})

					let obj = currObj.map.keyMap
					let arr = []
					for (const key in obj) {
						if (obj[key]['showed'] == true) {
							arr.push(obj[key])
						}
					}
					this.tHeader = arr

					this.tableData = currObj.map.list
					this.total = currObj.map.total
					this.listLoading = false
					this.tableKey = new Date().getTime()
				})
				.catch(() => {
					this.listLoading = false
				})
		},
		filterHandle() {
			this.pageIndex = 1
			this.getDataList()
		},
		// 双击详情
		dbRowClickHandle(row) {
			console.log(row)
			this.$router.push({ name: 'orderDetails', query: { orderId: row['order#id'], st: row['order#st'], type: row['order#order_type'], prn: row['prn'] } })
		},
		// 按钮操作
		btnClick(btn, row) {
			console.log(btn, row)
			switch (btn) {
				case 'resubmit':
					// 重新提交
					this.resubmitHandle(row)
					break
				case 'withdraw':
					// 测回
					this.withdrawHandle(row)
					break
				case 'detail':
					// 详情
					this.detailHandle(row)
					break
				case 'repulse':
					// 打回
					this.repulseHandle(row)
					break
				case 'pass':
					// 确认
					this.passHandle(row)
					break
				case 'addOrder':
					// 再次送检
					this.addOrderHandle(row)
					break
				case 'report':
					// 下载报告
					this.reportHandle(row)

					break
				case 'data':
					// 下载数据
					this.getdataHandle(row)
					break
				case 'delete':
					// 删除
					this.deleteHandle(row)
					break
				case 'update':
					// 更新
					this.updateHandle(row)
					break
				case 'cancelAppt':
					// 取消预约
					this.cancelReservationHandle(row)
					break
				case 'updateAppt':
					// 更改时间
					this.changeTimeHandle(row)
					break
				case 'contact':
					// 联系管理员
					this.contactAdminHandle(row)
					break
			}
		},

		// 联系管理员
		contactAdminHandle() {
			this.listLoading = true
			this.$http
				.get(this.$api.systemApi.getSys)
				.then(({ data }) => {
					console.log(data)
					this.listLoading = false
					this.$alert(`联系电话：${data.data.consultPhone}`, '联系管理员', {
						confirmButtonText: '确定',
						callback: () => {},
					})
				})
				.catch(() => {})
		},

		// 更改时间
		changeTimeHandle(row) {
			console.log(row, row['order#id'], row['prn'], row['order#order_type'], 'rowwwwwwww')
			this.timepanelVisible = true
			this.$nextTick(() => {
				this.updatOrderId = row['order#id']
				this.$refs.timepanel.init(row['prn'], row['order#order_type'], row['order#id'])
			})
		},
		updateTime(obj) {
			console.log(obj)
			this.listLoading = true
			let params = {
				orderId: this.updatOrderId,
				startTime: obj.startTime,
				endTime: obj.endTime,
			}
			this.$http
				.post(this.$api.orderApi.updateAppt, params)
				.then(({ data }) => {
					console.log(data)
					this.$message({
						message: '更改成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getDataList()
						},
					})
				})
				.catch(() => {
					this.listLoading = false
				})
		},
		//取消预约
		cancelReservationHandle(row) {
			this.$prompt('是否确认取消预约？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputType: 'textarea',
				inputPattern: /\S/,
				inputErrorMessage: '备注信息不能为空',
			})
				.then(({ value }) => {
					this.listLoading = true
					let params = {
						orderId: row['order#id'],
						cancelCause: value,
					}
					this.listLoading = true
					this.$http
						.post(this.$api.orderApi.cancelAppt, params)
						.then(({ data }) => {
							console.log(data)
							this.$message({
								message: '操作成功！',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getDataList()
								},
							})
						})
						.catch(() => {
							this.listLoading = false
						})
				})
				.catch(() => {
					this.listLoading = false
				})
		},
		showTimePanel() {
			this.timepanelVisible = true
			this.$nextTick(() => {
				this.updatOrderId = this.rowCont['order#id']
				this.$refs.timepanel.init(this.rowCont['prn'], this.rowCont['order#order_type'], this.rowCont['order#id'])
			})
		},

		// 重新提交
		resubmitHandle(row) {
			this.listLoading = true
			this.rowCont = row
			let params = {
				orderId: row['order#id'],
			}
			this.$http
				.post(this.$api.orderApi.orderSubmit, params)
				.then(({ data }) => {
					console.log(data, 'hhhhhhhh')

					if (data.data && data.data.code == 0) {
						this.orderFailVisible = true
						this.listLoading = false
						this.$nextTick(() => {
							this.$refs.orderFail.init(this.orderId, this.orderType)
						})
					} else {
						if (data.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getDataList()
								},
							})
						} else {
							this.getDataList()
						}
					}
				})
				.catch(() => {
					this.listLoading = false
				})
		},
		// 测回
		withdrawHandle(row) {
			console.log(row)
			this.$confirm('是否确认撤回订单信息？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				customClass: 'orderTips',
				type: 'warning',
			}).then(() => {
				this.listLoading = true
				let params = {
					orderId: row['order#id'],
				}
				this.$http
					.post(this.$api.orderApi.withdrawOrder, params)
					.then(() => {
						this.$message({
							message: '操作成功！',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							},
						})
					})
					.catch(() => {
						this.listLoading = false
					})
			})
		},
		// 详情
		detailHandle(row) {
			this.dbRowClickHandle(row)
		},
		// 打回
		repulseHandle(row) {
			this.$prompt('是否确认退回订单信息？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputType: 'textarea',
				inputPattern: /\S/,
				inputErrorMessage: '退回原因不能为空',
			})
				.then(({ value }) => {
					this.listLoading = true
					let params = {
						orderId: row['order#id'],
						isReview: false,
						failCause: value,
					}
					this.$http
						.post(this.$api.orderApi.orderReview, params)
						.then(({ data }) => {
							console.log(data)
							this.$message({
								message: '操作成功！',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getDataList()
								},
							})
						})
						.catch(() => {
							this.listLoading = false
						})
				})
				.catch(() => {
					this.listLoading = false
				})
		},
		// 确认
		passHandle(row) {
			this.$confirm('是否确认修改信息？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				customClass: 'orderTips',
				type: 'warning',
			}).then(() => {
				this.listLoading = true
				let params = {
					orderId: row['order#id'],
					isReview: true,
				}
				this.$http
					.post(this.$api.orderApi.orderReview, params)
					.then(({ data }) => {
						console.log(data)
						this.$message({
							message: '操作成功！',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							},
						})
					})
					.catch(() => {
						this.listLoading = false
					})
			})
		},
		// 再次送检
		addOrderHandle(row) {
			console.log(row)
			this.listLoading = true
			let params = {
				orderId: row['order#id'],
			}
			this.$http
				.post(this.$api.orderApi.copyOrder, params)
				.then(() => {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getDataList()
						},
					})
				})
				.catch(() => {
					this.listLoading = false
				})
		},
		// 下载报告
		reportHandle(row) {
			this.listLoading = true
			this.$http
				.post(this.$api.goodsApi.getReportUrl, { orderId: row['order#id'] })
				.then(res => {
					console.log(res, '下载报告ressssssss')
					this.listLoading = false
					let url = res.data.data.repDownUri
					if (url) {
						downloadFile(url, res.data.data.fileName)
						this.$http
							.get(this.$api.systemApi.getFirstReport)
							.then(res => {
								if (res.data.data.isFillQsa) {
									this.surveyVisible = true
								}
							})
							.catch(() => {
								this.listLoading = false
							})
					} else {
						this.$message.warning('暂未查询到报告内容!')
					}
				})
				.catch(() => {
					this.listLoading = false
				})
		},

		// 下载数据
		getdataHandle(row) {
			console.log(row)
			this.listLoading = true
			this.$http.post(this.$api.orderApi.searchAnnexByOrderId, { orderId: row['order#id'] }).then(res => {
				console.log(res, '下载数据ressssssss')
				this.listLoading = false
				this.downList = res.data.data
				if (Array.isArray(this.downList) && this.downList) {
					this.$refs.orderDown.dialogVisible = true
				} else {
					this.$message.warning('暂未查询到数据内容!')
				}
			}).catch(()=>{
				this.listLoading = false
			})
		},

		handleDown(v) {
			downloadFile(v.annexDownUri, v.fileName)
			this.$http.get(this.$api.systemApi.getFirstReport).then(res => {
				if (res.data.data.isFillQsa) {
					this.surveyVisible = true
				}
			}).catch(()=>{
				this.listLoading = false
			})
		},

		// 删除
		deleteHandle(row) {
			this.$confirm(`确定进行[ "删除"]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.listLoading = true
				let params = {
					orderIds: [row['order#id']],
				}
				this.$http
					.post(this.$api.orderApi.deleteOrder, params)
					.then(() => {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.pageIndex = 1
								this.getDataList()
							},
						})
					})
					.catch(() => {
						this.listLoading = false
					})
			})
		},
		// 更新
		updateHandle(row) {
			this.listLoading = true
			this.$http
				.post(this.$api.orderApi.updateReport, { orderId: row['order#id'] })
				.then(res => {
					console.log(res, '更新ressssssss')
					this.getDataList()
				})
				.catch(() => {
					this.listLoading = false
				})
			// this.dbRowClickHandle(row)
		},
		// tabChangeHandle
		tabChangeHandle(index) {
			this.currentTabIndex = index
			this.listLoading = true
			this.getDataList()
		},
		getRowColor() {
			return function (post, data) {
				let op = this.tHeader.filter(v => v.post == post)
				if (op.length && op[0].options && op[0].options.valueData && op[0].options.valueData.filter(v => v.st == data).length > 0) {
					return op[0].options.valueData.filter(v => v.st == data)[0].color
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.mod-personal {
	.mod-header {
		margin-bottom: 12px;
		.tab-list {
			font-size: 14px;
			.tab-item {
				display: inline-block;
				background: #f5f7fa;
				margin-right: 10px;
				height: 30px;
				line-height: 30px;
				padding: 0 12px;
				border-radius: 3px;
				cursor: pointer;
				&.active {
					background-color: #1460ae;
					color: #fff;
				}
			}
		}
	}
}
</style>
